export const b64EncodeUnicode = (str) => {
  btoa(encodeURIComponent(str));
};

export const UnicodeDecodeB64 = (str) => {
  return decodeURIComponent(atob(str));
};

export const generateRandomString = async (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const generateUniqueName = async (firstName) => {
  const randomString = await generateRandomString(6); // Adjust the length of the random string as needed
  return `${firstName}_${randomString}`;
};
